const ForwardIcon = () => {
  return (
    <svg
      className="forward_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
    >
      <path d="M1 11L5 6L1 1" stroke="#17171C" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default ForwardIcon
